<script>
  import DropDown from '../components/DropDown.svelte';
  import GridSearch from '../components/GridSearch.svelte';
  import ActivityLogItem from '../components/ActivityLogItem.svelte';
  import DatePicker from '../components/Flatpickr/DatePicker.svelte';
  import Loader from '../components/Loader.svelte';
  import InfiniteScroll from '../components/DataTable/InfiniteScroll.svelte';
  import { downloadCsvFile, mergeNotificationArr } from '../components/Helper.js';
  import { client } from 'root/api/index.js';
  import { onMount, getContext } from 'svelte';
  import ActivityDetailModal from '../components/ActivityDetailModal.svelte';
  import ClientsUpdateModal from '../components/clients/ClientsUpdateModal.svelte';

  const showDialog = getContext('showDialog');

  let unitUsers = [];
  let clients = [];
  let pageSize = 30;
  let pageNumber = 1;
  let totalPages = 0;
  let activityData = [];
  let isPaginationLoading = false;
  let activityModal;

  const getActivityList = () => {
    isPaginationLoading = true;
    client
      .activityList(pageSize, pageNumber, { ...extraFilter })
      .then((response) => {
        isPaginationLoading = false;
        if (response.data.pagination.pageNumber == 1) {
          activityData = [];
        }
        activityData = mergeNotificationArr(activityData, response.data.payload);
        totalPages = response.data.pagination.totalPage;
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };
  const getUnitUsers = () => {
    client
      .unitUsers({ units: [] })
      .then((response) => {
        let detail = response.data;
        unitUsers = detail.users.map((item) => {
          item.name = item.firstName + ' ' + item.lastName;
          return item;
        });
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };
  const getUnitDetail = () => {
    client.unitClients({ units: [] }).then((response) => {
      let detail = response.data;
      clients = detail.clients.map((item) => {
        item.name = item.name;
        return item;
      });
    });
  };

  onMount(() => {
    getUnitUsers();
    getUnitDetail();
    getActivityList();
  });
  let defaultFilter = {
    searchKeyword: '',
    clients: '',
    users: '',
    fromDate: '',
    toDate: '',
  };
  let extraFilter = { ...defaultFilter };
  let firstTimeLoad = true;
  const filterData = () => {
    if (firstTimeLoad) {
      firstTimeLoad = false;
      return false;
    }
    pageNumber = 1;
    totalPages = 0;
    activityData = [];
    getActivityList();
  };
  $: extraFilter && filterData();

  let clientUpdateModal;
  const showActivityDetail = (id) => {
    client
      .activityGet({ id: id })
      .then((response) => {
        if (response.data.info.showClient == 1) {
          clientUpdateModal.showModal(response.data.info);
        } else {
          activityModal.showModal(response.data.info);
        }
      })
      .catch((err) => {
        showDialog({ message: [err.message] });
      });
  };

  const downloadCsv = (logType) => {
    client
      .activityExport({
        ...extraFilter,
        logType,
      })
      .then(async (result) => {
        downloadCsvFile(result, 'activity-log-' + logType + '.csv');
      });
  };
</script>

<div class="h-100 p-3">
  <div class="d-flex flex-column h-100">
    <div class="block-header mb-2">
      <div class="row align-items-center">
        <div class="col"><h2 class="page-title">Activity Log</h2></div>
      </div>
    </div>

    <div class="page-content">
      <div class="d-flex flex-column h-100 card-content bg-white">
        <div class="d-flex flex-row">
          <div class="filter-content top-menu-filter w-100">
            <div class="d-flex flex-row justify-content-between w-100">
              <div class="d-flex flex-row align-items-center activity-filter-block">
                <DropDown
                  checkbox={true}
                  searchbox={true}
                  active={false}
                  title="Select User"
                  option={unitUsers}
                  Style="select-block"
                  removeIcon={true}
                  on:onClear={(event) => {
                    extraFilter.users = [];
                  }}
                  on:onSelect={(event) => {
                    extraFilter.users = event.detail.map((item) => {
                      item.id = item.userId;
                      return item;
                    });
                  }}
                />
                <DropDown
                  checkbox={true}
                  searchbox={true}
                  active={false}
                  title="Select Client"
                  option={clients}
                  Style="select-block me-1"
                  removeIcon={true}
                  on:onClear={(event) => {
                    extraFilter.clients = [];
                  }}
                  on:onSelect={(event) => {
                    extraFilter.clients = event.detail;
                  }}
                />
                <DatePicker
                  Style="me-1 filter-input-date-picker activity-log-input"
                  placeholder="From Date"
                  on:change={(value) => {
                    extraFilter.fromDate = value.detail[1];
                  }}
                />
                <DatePicker
                  Style="me-1 filter-input-date-picker activity-log-input"
                  placeholder="To Date"
                  on:change={(value) => {
                    extraFilter.toDate = value.detail[1];
                  }}
                />
              </div>

              <div class="d-flex right-action-btn">
                <GridSearch
                  bind:value={extraFilter.searchKeyword}
                  btnExport={false}
                  placeholder="Search"
                />

                <button
                  on:click={() => {
                    downloadCsv('all');
                  }}
                  class="mb-0 ms-1 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
                >
                  <svg
                    class="me-1 icon-16"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 512 512"
                    style="enable-background:new 0 0 512 512;"
                    xml:space="preserve"
                    ><g
                      ><g
                        ><path
                          d="M400,304.005c-8.832,0-16,7.168-16,16v144H32v-352h144c8.832,0,16-7.168,16-16c0-8.832-7.168-16-16-16H16			c-8.832,0-16,7.168-16,16v384c0,8.832,7.168,16,16,16h384c8.832,0,16-7.168,16-16v-160C416,311.173,408.832,304.005,400,304.005z"
                        /></g
                      ></g
                    ><g
                      ><g
                        ><path
                          d="M506.528,131.973l-128-112c-4.704-4.16-11.424-5.152-17.152-2.528C355.68,20.037,352,25.733,352,32.005v48h-9.472			c-102.848,0-191.36,76.768-205.92,178.592l-8.448,59.168c-1.056,7.456,3.232,14.688,10.368,17.28			c1.792,0.64,3.648,0.96,5.472,0.96c5.376,0,10.592-2.72,13.568-7.52l23.584-37.76c32.384-51.776,88.192-82.72,149.28-82.72H352v48			c0,6.272,3.68,11.968,9.376,14.56c5.664,2.592,12.416,1.632,17.152-2.528l128-112c3.488-3.04,5.472-7.392,5.472-12.032			S510.016,135.013,506.528,131.973z M384,220.741v-28.736c0-8.832-7.168-16-16-16h-37.568c-62.72,0-120.736,27.584-159.968,74.976			c17.28-80.032,89.184-138.976,172.064-138.976H368c8.832,0,16-7.168,16-16V67.269l87.712,76.736L384,220.741z"
                        /></g
                      ></g
                    ></svg
                  >
                  Export
                </button>
                <button
                  on:click={() => {
                    downloadCsv('user');
                  }}
                  class="mb-0 ms-1 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
                >
                  <svg
                    class="me-1 icon-16"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 512 512"
                    style="enable-background:new 0 0 512 512;"
                    xml:space="preserve"
                    ><g
                      ><g
                        ><path
                          d="M400,304.005c-8.832,0-16,7.168-16,16v144H32v-352h144c8.832,0,16-7.168,16-16c0-8.832-7.168-16-16-16H16			c-8.832,0-16,7.168-16,16v384c0,8.832,7.168,16,16,16h384c8.832,0,16-7.168,16-16v-160C416,311.173,408.832,304.005,400,304.005z"
                        /></g
                      ></g
                    ><g
                      ><g
                        ><path
                          d="M506.528,131.973l-128-112c-4.704-4.16-11.424-5.152-17.152-2.528C355.68,20.037,352,25.733,352,32.005v48h-9.472			c-102.848,0-191.36,76.768-205.92,178.592l-8.448,59.168c-1.056,7.456,3.232,14.688,10.368,17.28			c1.792,0.64,3.648,0.96,5.472,0.96c5.376,0,10.592-2.72,13.568-7.52l23.584-37.76c32.384-51.776,88.192-82.72,149.28-82.72H352v48			c0,6.272,3.68,11.968,9.376,14.56c5.664,2.592,12.416,1.632,17.152-2.528l128-112c3.488-3.04,5.472-7.392,5.472-12.032			S510.016,135.013,506.528,131.973z M384,220.741v-28.736c0-8.832-7.168-16-16-16h-37.568c-62.72,0-120.736,27.584-159.968,74.976			c17.28-80.032,89.184-138.976,172.064-138.976H368c8.832,0,16-7.168,16-16V67.269l87.712,76.736L384,220.741z"
                        /></g
                      ></g
                    ></svg
                  >
                  Export User
                </button>
                <button
                  on:click={() => {
                    downloadCsv('detail');
                  }}
                  class="mb-0 ms-1 bg-transparent border-0 btn-export d-flex flex-row align-items-center font-size-13"
                >
                  <svg
                    class="me-1 icon-16"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 512 512"
                    style="enable-background:new 0 0 512 512;"
                    xml:space="preserve"
                    ><g
                      ><g
                        ><path
                          d="M400,304.005c-8.832,0-16,7.168-16,16v144H32v-352h144c8.832,0,16-7.168,16-16c0-8.832-7.168-16-16-16H16			c-8.832,0-16,7.168-16,16v384c0,8.832,7.168,16,16,16h384c8.832,0,16-7.168,16-16v-160C416,311.173,408.832,304.005,400,304.005z"
                        /></g
                      ></g
                    ><g
                      ><g
                        ><path
                          d="M506.528,131.973l-128-112c-4.704-4.16-11.424-5.152-17.152-2.528C355.68,20.037,352,25.733,352,32.005v48h-9.472			c-102.848,0-191.36,76.768-205.92,178.592l-8.448,59.168c-1.056,7.456,3.232,14.688,10.368,17.28			c1.792,0.64,3.648,0.96,5.472,0.96c5.376,0,10.592-2.72,13.568-7.52l23.584-37.76c32.384-51.776,88.192-82.72,149.28-82.72H352v48			c0,6.272,3.68,11.968,9.376,14.56c5.664,2.592,12.416,1.632,17.152-2.528l128-112c3.488-3.04,5.472-7.392,5.472-12.032			S510.016,135.013,506.528,131.973z M384,220.741v-28.736c0-8.832-7.168-16-16-16h-37.568c-62.72,0-120.736,27.584-159.968,74.976			c17.28-80.032,89.184-138.976,172.064-138.976H368c8.832,0,16-7.168,16-16V67.269l87.712,76.736L384,220.741z"
                        /></g
                      ></g
                    ></svg
                  >
                  Detail Export
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="page-content p-3">
          {#if activityData.length <= 0 && !isPaginationLoading}
            <div class=" d-flex align-items-center justify-content-center h-100 w-100 flex-column">
              <svg
                width="40"
                height="40"
                viewBox="0 0 100 100"
                fill="#787e8d"
                ><path
                  d="M6.25 53.125V37.5H0V6.25H81.25V37.5H21.875L6.25 53.125ZM6.25 31.25H12.5V38.0371L19.2871 31.25H75V12.5H6.25V31.25ZM100 50V81.25H93.75V96.875L78.125 81.25H18.75V50H100ZM93.75 56.25H25V75H80.7129L87.5 81.7871V75H93.75V56.25Z"
                  fill=""
                ></path></svg
              >
              <span class="color-lead font-size-18 mt-3 d-block"
                >You don't have any activity log yet</span
              >
            </div>
          {/if}
          {#each activityData as item, itemkey}
            <div class="d-flex flex-column mb-3">
              <div class="activity-date-select">
                <span class="font-size-13 color-blue mb-1">{item.label}</span>
              </div>
              <div class="notification-list">
                <ul class="position-relative notification-list-ul px-0">
                  {#each item.values as itemData, itemdatakey}
                    <ActivityLogItem
                      itemData={itemData}
                      on:handleClick={(ev) => {
                        showActivityDetail(ev.detail);
                      }}
                    />
                  {/each}
                </ul>
              </div>
            </div>
          {/each}
          <InfiniteScroll
            threshold={300}
            hasMore={pageNumber < totalPages}
            isLoading={isPaginationLoading}
            on:loadMore={() => {
              pageNumber = pageNumber + 1;
              getActivityList();
            }}
          >
            <div
              class="scroll-spinner-container d-flex justify-content-center
							align-items-center"
            >
              <Loader Style="loader-block" />
            </div>
          </InfiniteScroll>
        </div>
      </div>
    </div>
  </div>
</div>

<ActivityDetailModal bind:this={activityModal} />

<ClientsUpdateModal bind:this={clientUpdateModal} />

<style lang="scss">
  /* .notification-list {
		ul {
			margin: 0px;
			padding: 0px;
			list-style: none;
			padding-top: 40px;
			margin-left: 40px;
			margin-top: 30px;
			list-style: none;
			padding-top: 46px;
			margin-left: 22px;
			margin-top: 10px;
			&:before {
				content: " ";
				background-color: $input-border-color;
				width: 3px;
				height: 100%;
				left: 0px;
				top: 0px;
				position: absolute;
				left: 0px;
			}
			&:after {
				content: " ";
				border: 3px solid $input-border-color;
				width: 15px;
				height: 15px;
				left: -3px;
				top: 0px;
				position: absolute;
				left: -6px;
				border-radius: 15px;
				background-color: #fff;
			}
		}
	} */
  .activity-date-select {
    background: rgba(35, 46, 60, 0.024);
    margin: -0.5rem -1rem;
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
    padding-left: 1rem;
    margin-bottom: 1em;
  }
</style>
